import React from 'react'
import SVG from 'react-svg-inline'
import ReactPlayer from 'react-player'

import Logo from 'img/zalando/branding.svg'
import CoverLogo from 'img/zalando/cover-logo.svg'
import zdtCover from 'img/zalando/zdt-cover.svg'
import zdtLogo from 'img/zalando/zdt-logo.svg'
import Modules from 'img/zalando/img-modules.svg'

const Zalando = () =>
  <div>


    <section className="container full">
      <div className="col-12-of-12">
        <img
          src={require('img/zalando/img-big.jpg')}
          alt="Zalando Phones"
        />
      </div>
    </section>

    <section className="container">
      <div className="client-quote">
        <blockquote>
          I joined the mobile apps team of Zalando during the Summer of 2016. The initial goal was to revamp the look & feel of the existing products while unifying their design language.
        </blockquote>
      </div>
    </section>

    <section className="container">
      <div className="col-12-of-12">
        <img
          src={require('img/zalando/img-iphones-pdp.jpg')}
          alt="Zalando Phones"
        />
      </div>
    </section>

    <section className="container">
      <div className="col-12-of-12">
        <img
          src={require('img/zalando/img-iphones-reviews-process.jpg')}
          alt="Zalando Phones"
        />
      </div>
    </section>

    <section className="container">
      <div className="col-12-of-12">
        <img
          src={require('img/zalando/img-ipad.jpg')}
          alt="Zalando Phones"
        />
      </div>
    </section>

    <section className="container">
      <div className="col-12-of-12">
        <img
          src={require('img/zalando/img-iphones-orders.jpg')}
          alt="Zalando Phones"
        />
      </div>
    </section>

    <section className="container">
      <div className="client-quote">
        <blockquote>
          I could formalise the updated design language and introduce the need of a proper design system, so we did come up with a Sketch template for any future work that needs to be done on the mobile apps.
        </blockquote>
      </div>
    </section>

    <section className="container full">
      <div className="col-12-of-12">
        <img
          src={require('img/zalando/img-laptops-sketch.jpg')}
          alt="Zalando Branding"
        />
      </div>
    </section>
    <section className="container full">
      <div className="col-12-of-12">
        <img
          src={require('img/zalando/img-modules.jpg')}
          alt="Zalando Branding"
        />
      </div>
    </section>


    <section className="container">
      <div className="client-quote">
        <blockquote>
          Besides working on the mobile apps team, I also had the opportunity to work on the zalando.design website and the Zalando Design Toolkit - a set of tools to speed up the work of designers at Zalando.
        </blockquote>
      </div>
    </section>


    <section className="container full">
      <div className="col-12-of-12">
        <SVG svg={Logo} width="100%" />
      </div>
    </section>

    <section className="container full">
      <div className="col-12-of-12">
        <img
          src={require('img/zalando/img-zalando-websites-1.jpg')}
          alt="Zalando Branding"
        />
      </div>
    </section>
    <section className="container full">
      <div className="col-12-of-12">
        <img
          src={require('img/zalando/img-zalando-websites-2.jpg')}
          alt="Zalando Branding"
        />
      </div>
    </section>

    <section className="container full">
      <div className="col-12-of-12">
        <SVG svg={zdtCover} width="100%" />
      </div>
    </section>

    <section className="container">
      <div className="client-quote">
        <blockquote>
          The Zalando Design Toolkit consists of a menubar app (using Electron) that acts as the wrapper for 5 webviews. The different sections are categorized as News, Files, Resources, Library & Settings.
        </blockquote>
      </div>
    </section>


    <section className="container">
      <div className="fullwidth-video-wrapper">
        <ReactPlayer
          url="https://player.vimeo.com/video/237215245"
          className="video-player"
          width="100%"
          height="100%"
          playing={true}
          playbackRate={1}
          loop={true}
          // volume={0}
          controls={true}
          // youtubeConfig={{ attributes: { preload: true } }}
          // TODO Add custom posters for videos (to be also used as fallback images) 👇 This is supposed to work: https://github.com/CookPete/react-player/issues/62
          fileConfig={{ attributes: { poster: 'https://placehold.it/100x100/' } }}
        />
      </div>
    </section>

    <section className="container">
      <div className="client-quote">
        <blockquote>
          That was one of the most entertaining projects I have designed and coded recently – Using different technologies than the ones I normally use, ended up building different websites, mac apps & browser extensions to put together the so called Zalando Design Toolkit.
        </blockquote>
      </div>
    </section>
  </div>

export default Zalando



// WEBPACK FOOTER //
// src/javascripts/clients/Zalando.js